(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7345],{

/***/ 74918:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products",
      function () {
        return __webpack_require__(23340);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ TabIconButton; },
/* harmony export */   "Y": function() { return /* binding */ TabButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17573);
/* harmony import */ var src_components_common_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78296);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73098);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68251);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            font-weight: 700;\n            color: ",
        " !important;\n            border-color: ",
        " !important;\n            b,\n            strong {\n              font-weight: 700;\n            }\n          "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            font-weight: 300;\n            color: ",
        ";\n            b,\n            strong {\n              font-weight: 300;\n            }\n          "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  && {\n    display: flex;\n    align-items: center;\n\n    min-width: min-content;\n    min-height: 26px;\n\n    font-size: 13px;\n    line-height: 21px;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    white-space: nowrap;\n\n    transition: all 0.2s ease;\n\n    color: ",
        ";\n    border-bottom: 1rpx solid\n      ",
        ";\n\n    ",
        " {\n      font-size: 14px;\n      padding-bottom: 6px;\n    }\n\n    br {\n      display: none;\n    }\n\n    &:hover,\n    &:focus {\n      color: ",
        ";\n      border-color: currentColor;\n    }\n\n    ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  && {\n    min-width: 24px;\n    justify-content: center;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var TabButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(src_components_common_Button__WEBPACK_IMPORTED_MODULE_1__/* .CleanButton */ .ux).withConfig({
    displayName: "TabButton",
    componentId: "sc-71a4751e-0"
})(_templateObject2(), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
    return theme.text.palette.primary;
}), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
    return (0,polished__WEBPACK_IMPORTED_MODULE_5__/* .transparentize */ .DZ)(0.6, theme.text.palette.primary);
}), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
    return theme.text.palette.accent;
}), function(param) {
    var $active = param.$active;
    return $active ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__.css)(_templateObject(), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
        return theme.text.palette.accent;
    }), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
        return theme.text.palette.accent;
    })) : (0,styled_components__WEBPACK_IMPORTED_MODULE_4__.css)(_templateObject1(), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
        return theme.text.palette.heavy;
    }));
});
var TabIconButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(TabButton).withConfig({
    displayName: "TabButton__TabIconButton",
    componentId: "sc-71a4751e-1"
})(_templateObject3());


/***/ }),

/***/ 43573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ PimImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_services_pim__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57539);






var PimImage = function(_param) {
    var src = _param.src, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src"
    ]);
    if (!src) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        src: (0,src_services_pim__WEBPACK_IMPORTED_MODULE_2__/* .getPimImageAssetUrl */ .p3)(src)
    }));
};


/***/ }),

/***/ 16001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ ScrollToSectionOnClick; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_providers_LayoutRegisterProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63085);
/* harmony import */ var src_components_common_ResponsiveUnit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47631);







var ScrollToSectionOnClick = function(_param) {
    var children = _param.children, id = _param.id, _offset = _param.offset, offset = _offset === void 0 ? 0 : _offset, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "id",
        "offset"
    ]);
    var ref;
    var layoutRegisterContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(src_providers_LayoutRegisterProvider__WEBPACK_IMPORTED_MODULE_2__/* .LayoutRegisterContext */ .D);
    var scrollToSection = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(px) {
        var section = document === null || document === void 0 ? void 0 : document.querySelector("#".concat(id));
        if (section != null) {
            var ref;
            var _fixed;
            window.scrollTo({
                top: section.getBoundingClientRect().top + window.scrollY - offset * px - ((_fixed = (ref = layoutRegisterContext === null || layoutRegisterContext === void 0 ? void 0 : layoutRegisterContext.ui.height) === null || ref === void 0 ? void 0 : ref.header.fixed) !== null && _fixed !== void 0 ? _fixed : 0) * px,
                behavior: "smooth"
            });
        }
    }, [
        id,
        offset,
        (ref = layoutRegisterContext === null || layoutRegisterContext === void 0 ? void 0 : layoutRegisterContext.ui.height) === null || ref === void 0 ? void 0 : ref.header.fixed
    ]);
    var clickCallback = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e, px) {
        var _props, ref, ref1;
        (ref = (_props = children.props).onClick) === null || ref === void 0 ? void 0 : ref.call(_props, e);
        (ref1 = props.onClick) === null || ref1 === void 0 ? void 0 : ref1.call(props, e);
        scrollToSection(px);
    }, [
        children.props,
        props,
        scrollToSection
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_common_ResponsiveUnit__WEBPACK_IMPORTED_MODULE_3__/* .ResponsiveUnit */ .D, {
        children: function(px) {
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(children, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
                onClick: function(e) {
                    return clickCallback(e, px);
                }
            }));
        }
    });
};


/***/ }),

/***/ 95175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ StickyMenuProvider; },
/* harmony export */   "W": function() { return /* binding */ StickyMenuContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36305);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var rambda__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49713);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





var StickyMenuContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)({
    activeSection: null,
    registeredSections: [],
    registerSection: function() {
        return null;
    },
    handleActiveSectionChange: function() {
        return null;
    }
});
var StickyMenuProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), registeredSections = ref[0], setRegisteredSections = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), activeSection = ref1[0], setActiveSection = ref1[1];
    var _index, _index1;
    var registerSection = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(section) {
        return setRegisteredSections(function(state) {
            return (0,rambda__WEBPACK_IMPORTED_MODULE_3__.sort)(function(a, b) {
                return ((_index = a.index) !== null && _index !== void 0 ? _index : 0) > ((_index1 = b.index) !== null && _index1 !== void 0 ? _index1 : 0) ? 1 : 0;
            }, (0,lodash__WEBPACK_IMPORTED_MODULE_1__.uniqBy)((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(state).concat([
                section
            ]), function(s) {
                return s.id;
            }));
        });
    }, [
        setRegisteredSections
    ]);
    var handleActiveSectionChange = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(value) {
        setActiveSection(value);
    }, [
        setActiveSection
    ]);
    var value = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return {
            activeSection: activeSection,
            registeredSections: registeredSections,
            registerSection: registerSection,
            handleActiveSectionChange: handleActiveSectionChange
        };
    }, [
        activeSection,
        registeredSections,
        handleActiveSectionChange,
        registerSection, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StickyMenuContext.Provider, {
        value: value,
        children: children
    });
};


/***/ }),

/***/ 226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ StickyMenuSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87379);
/* harmony import */ var react_hook_inview__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69671);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94829);
/* harmony import */ var src_components_common_StickyMenu_StickyMenuContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95175);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var Section = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].section.withConfig({
    displayName: "StickyMenuSection__Section",
    componentId: "sc-4d2b84b-0"
})(_templateObject());
var StickyMenuSection = function(_param) {
    var id = _param.id, label = _param.label, index = _param.index, threshold = _param.threshold, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "id",
        "label",
        "index",
        "threshold",
        "children"
    ]);
    var isDesktop = (0,react_use__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("(min-width: 992px)", true);
    var activeThreshold = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (typeof threshold === "object" && !Array.isArray(threshold)) {
            if (isDesktop) return threshold.desktop;
            return threshold.mobile;
        }
        return threshold;
    }, [
        threshold,
        isDesktop
    ]);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,react_hook_inview__WEBPACK_IMPORTED_MODULE_3__/* .useInView */ .Y)({
        threshold: activeThreshold
    }), 2), ref1 = ref[0], isVisible = ref[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(src_components_common_StickyMenu_StickyMenuContext__WEBPACK_IMPORTED_MODULE_4__/* .StickyMenuContext */ .W), handleActiveSectionChange = ref2.handleActiveSectionChange, registerSection = ref2.registerSection;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (isVisible) {
            handleActiveSectionChange(id);
        }
    }, [
        isVisible,
        handleActiveSectionChange,
        id
    ]);
    var hasChildren = !!children;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (id && label && hasChildren) {
            registerSection({
                id: id,
                label: label,
                index: index
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id,
        label,
        hasChildren
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Section, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props), {
        ref: ref1,
        id: id !== null && id !== void 0 ? id : undefined,
        children: children
    }));
};


/***/ }),

/***/ 25196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ StickyMenu; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(36305);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87379);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73098);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68251);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(17573);
/* harmony import */ var vendor_mods_styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10395);
/* harmony import */ var src_hooks_useRectMeasure__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48101);
/* harmony import */ var src_hooks_useWindowScroll__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87802);
/* harmony import */ var src_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10763);
/* harmony import */ var src_components_common_TabsSwiper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2277);
/* harmony import */ var src_components_common_StickyMenu_StickyMenuContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95175);
/* harmony import */ var src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12732);






function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      right: calc(var(--scrollbar-padding) / 2);\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .sticky-menu__navbar {\n      background: rgba(255, 255, 255, 0.85);\n    }\n    ",
        " {\n      .sticky-menu__navbar {\n        background: ",
        ";\n      }\n      .sticky-menu__button {\n        color: ",
        ";\n        border-color: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    backdrop-filter: blur(0px) !important;\n    .sticky-menu__navbar {\n      background: transparent !important;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: ",
        ";\n  top: calc(var(--header-fixed-height));\n\n  ",
        ";\n\n  display: flex;\n  justify-content: center;\n\n  width: 100%;\n  z-index: 10;\n\n  backdrop-filter: blur(8rpx);\n  transform: translate3d(0, 0, 0);\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  padding-top: 8px;\n  padding-bottom: 9px;\n  background: transparent;\n  transition: 0.25s;\n  height: ",
        "px;\n\n  ",
        " {\n    padding-top: 11px;\n    padding-bottom: 13px;\n    height: ",
        "px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: ",
        "px;\n  ",
        " {\n    height: ",
        "px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}













var height = {
    mobile: 42,
    desktop: 52
};
var Container = styled_components__WEBPACK_IMPORTED_MODULE_11__["default"].div.withConfig({
    displayName: "StickyMenu__Container",
    componentId: "sc-1526bfc7-0"
})(_templateObject3(), function(param) {
    var $fixed = param.$fixed;
    return $fixed ? "fixed" : "sticky";
}, function(param) {
    var $fixed = param.$fixed;
    return $fixed && (0,styled_components__WEBPACK_IMPORTED_MODULE_11__.css)(_templateObject());
}, (0,src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_10__/* .casePathEmptyString */ .Q)("$passedBanner")((0,styled_components__WEBPACK_IMPORTED_MODULE_11__.css)(_templateObject1(), src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.lessThan.desktop */ .BC.w.lessThan.desktop, (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .fromTheme */ .HW)(function(theme) {
    return (0,polished__WEBPACK_IMPORTED_MODULE_12__/* .transparentize */ .DZ)(0.15, theme.palette.background);
}), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .fromTheme */ .HW)(function(theme) {
    return theme.text.palette.heavy;
}), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .fromTheme */ .HW)(function(theme) {
    return (0,polished__WEBPACK_IMPORTED_MODULE_12__/* .transparentize */ .DZ)(0.15, theme.text.palette.heavy);
}))), (0,src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_10__/* .casePathEmptyString */ .Q)("$transparent")((0,styled_components__WEBPACK_IMPORTED_MODULE_11__.css)(_templateObject2())));
var Navbar = styled_components__WEBPACK_IMPORTED_MODULE_11__["default"].div.withConfig({
    displayName: "StickyMenu__Navbar",
    componentId: "sc-1526bfc7-1"
})(_templateObject4(), height.mobile, src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, height.desktop);
var FixedNavbarSpaceReservation = styled_components__WEBPACK_IMPORTED_MODULE_11__["default"].div.withConfig({
    displayName: "StickyMenu__FixedNavbarSpaceReservation",
    componentId: "sc-1526bfc7-2"
})(_templateObject5(), height.mobile, src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, height.desktop);
var StickyMenu = function(_param) {
    var _tabs = _param.tabs, tabs = _tabs === void 0 ? [] : _tabs, theme = _param.theme, activeTab = _param.activeTab, bannerHeight = _param.bannerHeight, transparentOnTop = _param.transparentOnTop, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_param, [
        "tabs",
        "theme",
        "activeTab",
        "bannerHeight",
        "transparentOnTop"
    ]);
    var y = (0,src_hooks_useWindowScroll__WEBPACK_IMPORTED_MODULE_7__/* .useWindowScroll */ .b)().y;
    var isDesktop = (0,src_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_14__/* .useMediaQuery */ .a)(src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, true);
    var ctx = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(src_components_common_StickyMenu_StickyMenuContext__WEBPACK_IMPORTED_MODULE_9__/* .StickyMenuContext */ .W);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,src_hooks_useRectMeasure__WEBPACK_IMPORTED_MODULE_6__/* .useRectMeasure */ .R)(isDesktop ? height.desktop : height.mobile), 2), containerRef = ref[0], navHeight = ref[1];
    var passedBanner = bannerHeight == null || y >= bannerHeight - navHeight;
    var isFixed = !bannerHeight ? false : y > navHeight;
    var allTabs = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(tabs).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(ctx.registeredSections));
    if (allTabs.length < 2) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(vendor_mods_styled_components__WEBPACK_IMPORTED_MODULE_5__/* .Theme */ .Q, {
        theme: theme || (passedBanner ? src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .defaultTheme */ .uH : src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .redTheme */ .MN),
        children: [
            isFixed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FixedNavbarSpaceReservation, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, props), {
                ref: containerRef,
                $fixed: isFixed,
                $passedBanner: passedBanner,
                $transparent: transparentOnTop ? y === 0 : false,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Navbar, {
                    className: "sticky-menu__navbar",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_TabsSwiper__WEBPACK_IMPORTED_MODULE_8__/* .TabsSwiper */ .T, {
                        tabs: allTabs,
                        activeTab: activeTab !== null && activeTab !== void 0 ? activeTab : ctx.activeSection,
                        buttonClassName: "sticky-menu__button"
                    })
                })
            }))
        ]
    });
};


/***/ }),

/***/ 2277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ TabsSwiper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87379);
/* harmony import */ var src_components_TrackedLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79017);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72873);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17739);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react_t7e__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var src_components_common_ScrollToSectionOnClick__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16001);
/* harmony import */ var src_components_common_Button_TabButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5049);
/* harmony import */ var src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71008);
/* harmony import */ var vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15201);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .swiper-slide {\n    min-width: min-content;\n    width: auto;\n  }\n  .swiper-wrapper {\n    gap: 20px;\n    max-width: max-content;\n    margin: 0 auto;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var SwiperContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__["default"])(src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_7__/* .ConstraintContainer */ .a).withConfig({
    displayName: "TabsSwiper__SwiperContainer",
    componentId: "sc-69bd32eb-0"
})(_templateObject());
var TabsSwiperComponent = function(param) {
    var tabs = param.tabs, activeTab = param.activeTab, scrollOffset = param.scrollOffset, buttonClassName = param.buttonClassName, setActiveTab = param.setActiveTab;
    var _ = (0,react_t7e__WEBPACK_IMPORTED_MODULE_10__.useTranslate)()._;
    var swiperRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (swiperRef.current) {
            var ref;
            (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slideTo(tabs.findIndex(function(param) {
                var id = param.id;
                return id === activeTab;
            }));
        }
    }, [
        tabs,
        activeTab
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SwiperContainer, {
        as: swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .Swiper */ .t,
        slidesPerView: "auto",
        threshold: 10,
        onSwiper: function(swiper) {
            return swiperRef.current = swiper;
        },
        children: tabs.map(function(tab) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .SwiperSlide */ .o, {
                children: tab.link ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_TrackedLink__WEBPACK_IMPORTED_MODULE_2__/* .TrackedLink */ .A, {
                    href: tab.link,
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_Button_TabButton__WEBPACK_IMPORTED_MODULE_6__/* .TabButton */ .Y, {
                        className: buttonClassName,
                        as: "a",
                        $active: activeTab === tab.id,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_8__/* .Markdown */ .U, {
                            children: _(tab.label)
                        })
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_ScrollToSectionOnClick__WEBPACK_IMPORTED_MODULE_5__/* .ScrollToSectionOnClick */ .d, {
                    id: tab.id,
                    offset: scrollOffset,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_Button_TabButton__WEBPACK_IMPORTED_MODULE_6__/* .TabButton */ .Y, {
                        $active: activeTab === tab.id,
                        className: buttonClassName,
                        onClick: function() {
                            return setActiveTab === null || setActiveTab === void 0 ? void 0 : setActiveTab(tab.id);
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_8__/* .Markdown */ .U, {
                            children: _(tab.label)
                        })
                    })
                })
            }, tab.id);
        })
    });
};
var TabsSwiper = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.memo)(TabsSwiperComponent);


/***/ }),

/***/ 89080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ MetaDescription; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



function MetaDescription(props) {
    var description = props.children;
    return description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }, "description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:description",
                content: description
            }, "og:description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:description",
                content: description
            }, "twitter:description")
        ]
    }) : null;
}


/***/ }),

/***/ 36458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useDelayedEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* eslint-disable react-hooks/exhaustive-deps */ 
var useDelayedEffect = function(effect, delay) {
    var deps = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
        delay
    ];
    var timeoutRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        timeoutRef.current = setTimeout(effect, delay);
        return function() {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, deps);
};


/***/ }),

/***/ 57402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ ProductsLegalMentions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73098);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87379);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17739);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_t7e__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71008);
/* harmony import */ var vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15201);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 21px;\n  margin-bottom: 8px;\n  max-width: 900px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-top: 50px;\n\n  ",
        " {\n    padding-top: 90px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-top: 20px;\n  border-top: 1rpx solid #d6d6d6;\n  ",
        " {\n    padding-top: 30px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var Paragraph = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].p.withConfig({
    displayName: "ProductsLegalMentions__Paragraph",
    componentId: "sc-5b3229a-0"
})(_templateObject());
var Container = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__["default"])(src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_4__/* .ConstraintContainer */ .a).withConfig({
    displayName: "ProductsLegalMentions__Container",
    componentId: "sc-5b3229a-1"
})(_templateObject1(), src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var InnerContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].div.withConfig({
    displayName: "ProductsLegalMentions__InnerContainer",
    componentId: "sc-5b3229a-2"
})(_templateObject2(), src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var ProductsLegalMentions = function() {
    var _ = (0,react_t7e__WEBPACK_IMPORTED_MODULE_7__.useTranslate)()._;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(InnerContainer, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Paragraph, {
                    children: [
                        "*",
                        _("These class III medical devices are regulated health products which bear, under this regulation, the CE marking. Manufacturer: MATEX LAB SPA, 2 via Carlo Urbani Brindisi, Italy. Please carefully read the instructions in the leaflets. The use of these products requires the intervention of a healthcare professional.")
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Paragraph, {
                    children: [
                        "**",
                        _("These class: IIb for Sectum, IIa for Zaffiro, IIb for Plasma IQ, Medical Devices are regulated health products which bear, under this regulation, the CE mark. Manufacturer: B&K, Domaniewska 37, Warsaw, Poland. Please carefully read the instructions in the leaflets. The use of these products requires the intervention of a healthcare professional.")
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Paragraph, {
                    children: [
                        "***",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_5__/* .Markdown */ .U, {
                            children: _("Neauvia Cosmeceuticals are cosmetic products according to Regulation 1223/2009")
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 23340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ products; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/styles/designs.ts
var designs = __webpack_require__(73098);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/styles/theme.ts + 3 modules
var theme = __webpack_require__(68251);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/modules/products/assets/products-banner-mobile.jpg
/* harmony default export */ var products_banner_mobile = ({"src":"/_next/static/media/products-banner-mobile.6000e49a.jpg","height":400,"width":440,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAHAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAgEAABAwIHAAAAAAAAAAAAAAABAAIDEhUEBSEiUYGh/8QAFQEBAQAAAAAAAAAAAAAAAAAAAwT/xAAWEQEBAQAAAAAAAAAAAAAAAAAAATH/2gAMAwEAAhEDEQA/AIWnPZMWGXJhgbNVuBNenHvaIiC1Tr//2Q==","blurWidth":8,"blurHeight":7});
// EXTERNAL MODULE: ./vendor/mods/media-breakpoints-fresnel/components/Media.tsx
var Media = __webpack_require__(50696);
;// CONCATENATED MODULE: ./src/modules/products/components/ProductsBanner/ProductsBannerImageMobile.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 1;\n  justify-self: center;\n  height: 360px;\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  object-fit: cover;\n  object-position: center 18px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 2;\n  position: absolute;\n  width: 100%;\n  height: 104px;\n  left: 0px;\n  top: 0;\n  background: linear-gradient(\n    180deg,\n    #cd0338,\n    rgba(205, 3, 56, 0.39) 46.35%,\n    rgba(205, 3, 56, 0) 100%\n  );\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var ImageContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductsBannerImageMobile__ImageContainer",
    componentId: "sc-29ec894f-0"
})(_templateObject());
var StyledImage = (0,styled_components_browser_esm["default"])((image_default())).withConfig({
    displayName: "ProductsBannerImageMobile__StyledImage",
    componentId: "sc-29ec894f-1"
})(_templateObject1());
var Gradient = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductsBannerImageMobile__Gradient",
    componentId: "sc-29ec894f-2"
})(_templateObject2());
var ProductsBannerImageMobile = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Media/* Media */.pU, {
        lessThan: "desktop",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                    src: products_banner_mobile,
                    layout: "fill",
                    sizes: "100vw"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/modules/products/assets/products-banner.jpg
/* harmony default export */ var products_banner = ({"src":"/_next/static/media/products-banner.656b53f8.jpg","height":460,"width":1920,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAACAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAbEAACAgMBAAAAAAAAAAAAAAABAgADBBESE//EABUBAQEAAAAAAAAAAAAAAAAAAAME/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAJB/9oADAMBAAIRAxEAPwCcmRe/kjXWMrXoCCxII43ERAU1j//Z","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/products/components/ProductsBanner/ProductsBannerImageDesktop.tsx

function ProductsBannerImageDesktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-self: center;\n  height: 327px;\n  position: relative;\n"
    ]);
    ProductsBannerImageDesktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductsBannerImageDesktop_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  object-fit: cover;\n  object-position: center center;\n"
    ]);
    ProductsBannerImageDesktop_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var ProductsBannerImageDesktop_ImageContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductsBannerImageDesktop__ImageContainer",
    componentId: "sc-6df526e7-0"
})(ProductsBannerImageDesktop_templateObject());
var ProductsBannerImageDesktop_StyledImage = (0,styled_components_browser_esm["default"])((image_default())).withConfig({
    displayName: "ProductsBannerImageDesktop__StyledImage",
    componentId: "sc-6df526e7-1"
})(ProductsBannerImageDesktop_templateObject1());
var ProductsBannerImageDesktop = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* Media */.pU, {
        greaterThanOrEqual: "desktop",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsBannerImageDesktop_ImageContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsBannerImageDesktop_StyledImage, {
                src: products_banner,
                layout: "fill",
                sizes: "100vw"
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/common/StickyMenu/index.tsx
var StickyMenu = __webpack_require__(25196);
// EXTERNAL MODULE: ./src/models/pim/index.ts
var pim = __webpack_require__(82445);
// EXTERNAL MODULE: ./src/components/common/StickyMenu/StickyMenuSection.tsx
var StickyMenuSection = __webpack_require__(226);
// EXTERNAL MODULE: ./src/hooks/useRectMeasure.ts
var useRectMeasure = __webpack_require__(48101);
;// CONCATENATED MODULE: ./src/modules/products/components/ProductsBanner/index.tsx


function ProductsBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n\n  height: 360px;\n  ",
        " {\n    height: 327px;\n  }\n"
    ]);
    ProductsBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductsBanner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n"
    ]);
    ProductsBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductsBanner_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  position: relative;\n  clip-path: polygon(60px 0, 100% 0, 0 100%);\n  clip-path: polygon(0 0, 40% 0, 100% 100%, 95% 100%);\n  width: 73px;\n  height: 100%;\n  top: 0;\n  right: 500px;\n  z-index: 0;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    ProductsBanner_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: 28px;\n  bottom: 54px;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n\n  ",
        " {\n    left: 0;\n    height: 100%;\n    width: 100%;\n    bottom: 0;\n    align-items: center;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 45px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}












var Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductsBanner__Container",
    componentId: "sc-4a0df5a1-0"
})(ProductsBanner_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ImagesContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductsBanner__ImagesContainer",
    componentId: "sc-4a0df5a1-1"
})(ProductsBanner_templateObject1());
var Needle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductsBanner__Needle",
    componentId: "sc-4a0df5a1-2"
})(ProductsBanner_templateObject2(), (0,theme/* fromTheme */.HW)(function(theme) {
    return theme.text.palette.accent;
}), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var InnerContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductsBanner__InnerContainer",
    componentId: "sc-4a0df5a1-3"
})(_templateObject3(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var DesktopStickyMenu = (0,styled_components_browser_esm["default"])(StickyMenu/* StickyMenu */.a).withConfig({
    displayName: "ProductsBanner__DesktopStickyMenu",
    componentId: "sc-4a0df5a1-4"
})(_templateObject4());
var stickyMenuSections = [
    {
        id: pim/* ProductCategoryCode.Fillers */.qv.Fillers,
        label: "fillers"
    },
    {
        id: pim/* ProductCategoryCode.Devices */.qv.Devices,
        label: "devices"
    },
    {
        id: pim/* ProductCategoryCode.Cosmeceuticals */.qv.Cosmeceuticals,
        label: "cosmeceuticals"
    }, 
];
var ProductsBanner = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useRectMeasure/* useRectMeasure */.R)(), 2), bannerRef = ref[0], height = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm.ThemeProvider, {
                theme: theme/* redTheme */.MN,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyMenuSection/* StickyMenuSection */.T, {
                    threshold: 1,
                    as: Container,
                    id: null,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* MediaDirect */.UT, {
                            lessThan: "desktop",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyMenu/* StickyMenu */.a, {
                                tabs: stickyMenuSections,
                                bannerHeight: height
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImagesContainer, {
                            ref: bannerRef,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsBannerImageMobile, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsBannerImageDesktop, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Needle, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* MediaDirect */.UT, {
                greaterThanOrEqual: "desktop",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopStickyMenu, {
                    tabs: stickyMenuSections
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/common/StickyMenu/StickyMenuContext.tsx
var StickyMenuContext = __webpack_require__(95175);
// EXTERNAL MODULE: ./src/components/seo/MetaTitle.tsx
var MetaTitle = __webpack_require__(71508);
// EXTERNAL MODULE: ./node_modules/react-t7e/lib/index.js
var lib = __webpack_require__(17739);
// EXTERNAL MODULE: ./src/components/seo/MetaDescription.tsx
var MetaDescription = __webpack_require__(89080);
// EXTERNAL MODULE: ./src/modules/products/components/ProductsLegalMentions.tsx
var ProductsLegalMentions = __webpack_require__(57402);
// EXTERNAL MODULE: ./vendor/mods/markdown/components/Markdown.tsx
var Markdown = __webpack_require__(15201);
;// CONCATENATED MODULE: ./src/modules/products/components/ProductsNeedleSegment.tsx

function ProductsNeedleSegment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  position: absolute;\n  top: 27px;\n  bottom: 35px;\n  clip-path: polygon(0 0, 40% 0, 100% 100%, 95% 100%);\n  left: -64px;\n  width: 37px;\n  max-width: 37px;\n  max-height: 164px;\n\n  ",
        " {\n    top: 27px;\n    bottom: 9px;\n    left: -83px;\n    width: 41px;\n    max-width: 41px;\n    max-height: 184px;\n  }\n\n  ",
        " {\n    left: auto;\n    right: -64px;\n    clip-path: polygon(60% 0, 100% 0, 5% 100%, 0 100%);\n\n    ",
        " {\n      right: -83px;\n    }\n  }\n"
    ]);
    ProductsNeedleSegment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductsNeedleSegment_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 24px;\n  font-weight: 300;\n  line-height: 29px;\n  color: ",
        ";\n  text-transform: uppercase;\n  margin-bottom: 24px;\n\n  ",
        " {\n    font-size: 32px;\n    font-weight: 300;\n    line-height: 32px;\n    letter-spacing: 0.02em;\n    margin-bottom: 29px;\n  }\n"
    ]);
    ProductsNeedleSegment_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductsNeedleSegment_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 21px;\n  color: ",
        ";\n  margin-bottom: 36px;\n\n  ",
        " {\n    font-size: 16px;\n    font-weight: 300;\n    line-height: 24px;\n  }\n\n  ",
        " {\n    max-width: 270px;\n  }\n"
    ]);
    ProductsNeedleSegment_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductsNeedleSegment_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n\n  ",
        " {\n    left: 35px;\n  }\n"
    ]);
    ProductsNeedleSegment_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







var ProductsNeedleSegment_Needle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductsNeedleSegment__Needle",
    componentId: "sc-73a57a9a-0"
})(ProductsNeedleSegment_templateObject(), (0,theme/* fromTheme */.HW)(function(theme) {
    return theme.text.palette.accent;
}), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, theme/* dirRTL */.gX, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Heading = styled_components_browser_esm["default"].h1.withConfig({
    displayName: "ProductsNeedleSegment__Heading",
    componentId: "sc-73a57a9a-1"
})(ProductsNeedleSegment_templateObject1(), (0,theme/* fromTheme */.HW)(function(theme) {
    return theme.text.palette.accent;
}), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Description = styled_components_browser_esm["default"].p.withConfig({
    displayName: "ProductsNeedleSegment__Description",
    componentId: "sc-73a57a9a-2"
})(ProductsNeedleSegment_templateObject2(), (0,theme/* fromTheme */.HW)(function(theme) {
    return theme.text.palette.gray3;
}), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var ProductsNeedleSegment_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductsNeedleSegment__Container",
    componentId: "sc-73a57a9a-3"
})(ProductsNeedleSegment_templateObject3(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var ProductsNeedleSegment = function(param) {
    var heading = param.heading, description = param.description;
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductsNeedleSegment_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsNeedleSegment_Needle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                        children: _(heading)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: _(description)
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/common/PimImage.tsx
var PimImage = __webpack_require__(43573);
// EXTERNAL MODULE: ./src/hooks/directus/useTranslateItem.ts
var useTranslateItem = __webpack_require__(70057);
// EXTERNAL MODULE: ./src/components/TrackedLink.tsx
var TrackedLink = __webpack_require__(79017);
// EXTERNAL MODULE: ./src/services/route.ts + 1 modules
var route = __webpack_require__(38325);
;// CONCATENATED MODULE: ./src/modules/products/components/ProductsSectionItems/ProductsSectionItem.tsx

function ProductsSectionItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  height: 136px;\n  width: 100%;\n\n  img {\n    object-fit: contain;\n  }\n\n  ",
        " {\n    height: 180px;\n  }\n"
    ]);
    ProductsSectionItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductsSectionItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n  line-height: 21px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  text-align: center;\n  font-size: 14px;\n  margin-top: 10px;\n\n  ",
        " {\n    font-size: 18px;\n    margin-top: 27px;\n  }\n"
    ]);
    ProductsSectionItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductsSectionItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 150px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n\n  &:hover {\n    cursor: pointer;\n  }\n"
    ]);
    ProductsSectionItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var ProductsSectionItem_ImageContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductsSectionItem__ImageContainer",
    componentId: "sc-c769b372-0"
})(ProductsSectionItem_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Title = styled_components_browser_esm["default"].h2.withConfig({
    displayName: "ProductsSectionItem__Title",
    componentId: "sc-c769b372-1"
})(ProductsSectionItem_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProductsSectionItem_Container = styled_components_browser_esm["default"].a.withConfig({
    displayName: "ProductsSectionItem__Container",
    componentId: "sc-c769b372-2"
})(ProductsSectionItem_templateObject2());
var ProductsSectionItem = function(param) {
    var product = param.product;
    var ref;
    var translatedProduct = (0,useTranslateItem/* useTranslateItem */.L)(product);
    if (!(product === null || product === void 0 ? void 0 : (ref = product.image) === null || ref === void 0 ? void 0 : ref.id)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
        href: route/* route.products */.BC.products().page(product),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductsSectionItem_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsSectionItem_ImageContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PimImage/* PimImage */.o, {
                        src: product.image.id,
                        alt: translatedProduct.name,
                        layout: "fill",
                        sizes: "(min-width: 1000px) 33vw, 50vw",
                        quality: 100
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                    children: translatedProduct.name
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 12 modules
var swiper_react = __webpack_require__(72873);
;// CONCATENATED MODULE: ./src/modules/products/components/ProductsSectionItems/ProductsSectionItemsSwiper.tsx

function ProductsSectionItemsSwiper_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .swiper-slide {\n    width: auto;\n  }\n"
    ]);
    ProductsSectionItemsSwiper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductsSectionItemsSwiper_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 25px;\n  position: relative;\n  margin-right: calc(-1 * var(--constraint-container-right-inner-margin));\n  margin-left: calc(-1 * var(--constraint-container-left-inner-margin));\n\n  ",
        " {\n    margin-left: 160px;\n  }\n"
    ]);
    ProductsSectionItemsSwiper_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var StyleSwiper = (0,styled_components_browser_esm["default"])(swiper_react/* Swiper */.t).withConfig({
    displayName: "ProductsSectionItemsSwiper__StyleSwiper",
    componentId: "sc-3c4e898b-0"
})(ProductsSectionItemsSwiper_templateObject());
var ProductsSectionItemsSwiper_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductsSectionItemsSwiper__Container",
    componentId: "sc-3c4e898b-1"
})(ProductsSectionItemsSwiper_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProductSectionItemsSwiper = function(param) {
    var products = param.products;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsSectionItemsSwiper_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleSwiper, {
            slidesPerView: "auto",
            centeredSlides: true,
            spaceBetween: 30,
            children: products.map(function(product) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsSectionItem, {
                        product: product
                    })
                }, product.code);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/modules/products/components/ProductsSectionItems/index.tsx

function ProductsSectionItems_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: ",
        ";\n  grid-row-gap: 104px;\n  grid-column-gap: 70px;\n"
    ]);
    ProductsSectionItems_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductsSectionItems_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 50px;\n\n  ",
        " {\n    margin-top: 104px;\n  }\n"
    ]);
    ProductsSectionItems_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var ProductsContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductsSectionItems__ProductsContainer",
    componentId: "sc-79a6674f-0"
})(ProductsSectionItems_templateObject(), function(param) {
    var $noOfColumns = param.$noOfColumns;
    return "auto ".repeat($noOfColumns);
});
var ProductsSectionItems_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductsSectionItems__Container",
    componentId: "sc-79a6674f-1"
})(ProductsSectionItems_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProductsSectionItems = function(param) {
    var products = param.products, _noOfColumns = param.noOfColumns, noOfColumns = _noOfColumns === void 0 ? 3 : _noOfColumns;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductsSectionItems_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* Media */.pU, {
                greaterThanOrEqual: "desktop",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsContainer, {
                    $noOfColumns: noOfColumns,
                    children: products.map(function(product) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsSectionItem, {
                            product: product
                        }, product.code);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* Media */.pU, {
                lessThan: "desktop",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSectionItemsSwiper, {
                    products: products
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/common/ConstraintContainer.tsx
var ConstraintContainer = __webpack_require__(71008);
// EXTERNAL MODULE: ./src/utils/casePathEmptyString.ts
var casePathEmptyString = __webpack_require__(12732);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/hooks/useAPIs.ts
var useAPIs = __webpack_require__(53100);
// EXTERNAL MODULE: ./src/models/query.ts
var query = __webpack_require__(19162);
;// CONCATENATED MODULE: ./src/modules/products/hooks/useProductsListQuery.ts




var fetchProductsListQuery = function(apis, params) {
    return {
        queryKey: (0,_to_consumable_array/* default */.Z)(query/* QueryKey.Products */.S.Products).concat([
            params
        ]),
        queryFn: function() {
            return apis.pim.products.list(params);
        }
    };
};
var useProductsListQuery = function(params) {
    var apis = (0,useAPIs/* useAPIs */.V)();
    return (0,es.useQuery)(fetchProductsListQuery(apis, params));
};

// EXTERNAL MODULE: ./src/hooks/useDelayedEffect.ts
var useDelayedEffect = __webpack_require__(36458);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/rambda/dist/rambda.esm.js
var rambda_esm = __webpack_require__(49713);
;// CONCATENATED MODULE: ./src/modules/products/components/ProductsInfoSection.tsx

function ProductsInfoSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  margin-top: 42px;\n\n  ",
        " {\n    margin-top: 70px;\n  }\n"
    ]);
    ProductsInfoSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductsInfoSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 457px;\n  height: 256px;\n  position: relative;\n"
    ]);
    ProductsInfoSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductsInfoSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 400px;\n  ",
        " {\n    max-width: 640px;\n    margin-left: 115px;\n    ",
        " {\n      margin-right: 115px;\n      margin-left: 0;\n    }\n  }\n"
    ]);
    ProductsInfoSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductsInfoSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        && {\n          ",
        " {\n            ",
        " {\n              max-width: 420px;\n              margin-left: 185px;\n              ",
        " {\n                margin-right: 185px;\n                margin-left: 0;\n              }\n            }\n          }\n        }\n      "
    ]);
    ProductsInfoSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ProductsInfoSection_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  width: 100%;\n\n  ",
        " {\n    justify-content: ",
        ";\n\n    ",
        ";\n  }\n"
    ]);
    ProductsInfoSection_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
















var ProductsInfoSection_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductsInfoSection__Container",
    componentId: "sc-a4760cbd-0"
})(ProductsInfoSection_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProductsInfoSection_ImageContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductsInfoSection__ImageContainer",
    componentId: "sc-a4760cbd-1"
})(ProductsInfoSection_templateObject1());
var SegmentContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductsInfoSection__SegmentContainer",
    componentId: "sc-a4760cbd-2"
})(ProductsInfoSection_templateObject2(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, theme/* dirRTL */.gX);
var HeadingRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductsInfoSection__HeadingRow",
    componentId: "sc-a4760cbd-3"
})(ProductsInfoSection_templateObject4(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, function(param) {
    var $isImageDisplayed = param.$isImageDisplayed;
    return $isImageDisplayed ? "center" : "flex-start";
}, (0,casePathEmptyString/* casePathEmptyString */.Q)("$isImageDisplayed")((0,styled_components_browser_esm.css)(ProductsInfoSection_templateObject3(), SegmentContainer, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, theme/* dirRTL */.gX)));
var ProductsInfoSection = function(param) {
    var category = param.category, title = param.title, description = param.description, image = param.image, noOfColumns = param.noOfColumns, _threshold = param.threshold, threshold = _threshold === void 0 ? {
        desktop: 0.5,
        mobile: 0.8
    } : _threshold;
    var router = (0,next_router.useRouter)();
    var containerRef = (0,react.useRef)(null);
    var ref = useProductsListQuery({
        filter: {
            categories: {
                categories_code: {
                    _eq: category
                }
            }
        }
    }), products = ref.data;
    (0,useDelayedEffect/* useDelayedEffect */.W)(function() {
        if (!(0,rambda_esm.isNil)(router.query[category]) && containerRef.current) {
            window.scrollTo({
                behavior: "smooth",
                top: containerRef.current.getBoundingClientRect().top - 200
            });
        }
    }, 250);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyMenuSection/* StickyMenuSection */.T, {
        as: ConstraintContainer/* ConstraintContainer */.a,
        id: category,
        threshold: threshold,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsInfoSection_Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeadingRow, {
                    ref: containerRef,
                    $isImageDisplayed: !!image,
                    children: [
                        image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* Media */.pU, {
                            greaterThanOrEqual: "desktop",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsInfoSection_ImageContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: image,
                                    layout: "fill",
                                    sizes: "50vw",
                                    quality: 100
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SegmentContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsNeedleSegment, {
                                heading: title,
                                description: description
                            })
                        })
                    ]
                })
            }),
            products && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsSectionItems, {
                products: products.data,
                noOfColumns: noOfColumns
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/modules/products/assets/cosmeceuticals/heading-image.png
/* harmony default export */ var heading_image = ({"src":"/_next/static/media/heading-image.e445fe5a.png","height":947,"width":2480,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAMFBMVEVMaXHAdoPLNk7BYG7BY3THPlO5hozAdH7BlZzHMEu9eYXCWWe8jJKc//S+parKTGDw3yMXAAAAD3RSTlMAoo2YX5/K7EZ5MYiyGknhlljvAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIElEQVQImWNg4OXjYAABRnZ+fh42Ri4GTlYmJmZuZhYAB6cAjoJcrDYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./src/modules/products/assets/fillers/heading-image.jpg
/* harmony default export */ var fillers_heading_image = ({"src":"/_next/static/media/heading-image.f26c570d.jpg","height":512,"width":914,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAgEAAABQMFAAAAAAAAAAAAAAAAAQIDBBESIQUGEyJh/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQP/xAAZEQADAAMAAAAAAAAAAAAAAAAAAQIxccH/2gAMAwEAAhEDEQA/ALvcMUpUvT7nXEcU1KysVSvYsH5gAACKXiddZ//Z","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./src/pages/products/index.tsx












var ProductsPage = function() {
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTitle/* MetaTitle */.p, {
                children: _("Products - Fillers, Devices, Cosmeceuticals")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaDescription/* MetaDescription */.l, {
                children: _("Discover Neauvia products. PEG-HA fillers, energy-based devices and advanced cosmeceutical line range of products for the aesthetic and surgical markets")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyMenuContext/* StickyMenuProvider */.Q, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsBanner, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsInfoSection, {
                        category: pim/* ProductCategoryCode.Fillers */.qv.Fillers,
                        title: _("fillers"),
                        description: _("Neauvia HA fillers* are based on a unique cross linker technology SMART CROSSLINKING TECHNOLOGY – with PEG, that gives our products a high safety and tolerability profile and that allows our fillers to perfectly integrate into the various anatomical planes."),
                        image: fillers_heading_image,
                        threshold: {
                            desktop: 0.4,
                            mobile: 0.8
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsInfoSection, {
                        category: pim/* ProductCategoryCode.Devices */.qv.Devices,
                        title: _("devices"),
                        description: _("Neauvia provides an energy-based range of products** for the aesthetic and surgical markets. Neauvia devices are characterized by sleek, modern design and advanced electromedical engineering in related fields such as electrosurgical, radiofrequency treatment, thermal-lifting, skin photo-biostimulation and cosmetology."),
                        noOfColumns: 4
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsInfoSection, {
                        category: pim/* ProductCategoryCode.Cosmeceuticals */.qv.Cosmeceuticals,
                        title: _("cosmeceuticals"),
                        description: _("cosmeceuticals.description"),
                        image: heading_image,
                        threshold: {
                            desktop: 0.2,
                            mobile: 0.8
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsLegalMentions/* ProductsLegalMentions */.z, {})
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var products = (ProductsPage);


/***/ }),

/***/ 69671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* reexport */ esm_useInView; },
  "R": function() { return /* reexport */ esm_useObserver; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-hook-inview/dist/esm/useObserver.js

/**
 * useObserver
 * @param callback IntersectionObserverCallback
 * @param options IntersectionObserverInit
 * @param externalState React.ComponentState[]
 */
const useObserver = (callback, { root, rootMargin, threshold } = {}, externalState = []) => {
    const target = (0,react.useRef)(null);
    const observer = (0,react.useRef)(null);
    const setTarget = (0,react.useCallback)((node) => {
        if (target.current && observer.current) {
            observer.current.unobserve(target.current);
            observer.current.disconnect();
            observer.current = null;
        }
        if (node) {
            observer.current = new IntersectionObserver(callback, { root, rootMargin, threshold });
            observer.current.observe(node);
            target.current = node;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [target, root, rootMargin, threshold, ...externalState]);
    return setTarget;
};
/* harmony default export */ var esm_useObserver = (useObserver);

;// CONCATENATED MODULE: ./node_modules/react-hook-inview/dist/esm/useInView.js


/**
 * useInView
 * @param options IntersectionObserverInit
 * @param externalState React.ComponentState[]
 */
const useInView = ({ root, rootMargin, threshold, unobserveOnEnter, target, onEnter, onLeave } = {}, externalState = []) => {
    const [state, setState] = (0,react.useState)({
        inView: false,
        entry: null,
        observer: null,
    });
    const callback = (0,react.useCallback)(([entry], observer) => {
        const inThreshold = observer.thresholds.some((t) => entry.intersectionRatio >= t);
        const inView = inThreshold && entry.isIntersecting;
        setState({
            inView,
            entry,
            observer,
        });
        // unobserveOnEnter
        if (inView && unobserveOnEnter) {
            observer.unobserve(entry.target);
            observer.disconnect();
        }
        // Legacy callbacks
        if (inView) {
            onEnter === null || onEnter === void 0 ? void 0 : onEnter(entry, observer);
        }
        else {
            onLeave === null || onLeave === void 0 ? void 0 : onLeave(entry, observer);
        }
    }, [onEnter, onLeave, unobserveOnEnter]);
    const setTarget = esm_useObserver(callback, { root, rootMargin, threshold }, [unobserveOnEnter, ...externalState]);
    // Legacy 'target' option
    (0,react.useEffect)(() => {
        if (target === null || target === void 0 ? void 0 : target.current)
            setTarget(target.current);
    }, [target, setTarget]);
    return [setTarget, state.inView, state.entry, state.observer];
};
/* harmony default export */ var esm_useInView = (useInView);

;// CONCATENATED MODULE: ./node_modules/react-hook-inview/dist/esm/index.js




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(74918); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);